import React, { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputCombo from "../../helpers/InputCombo";

import edit from "../../edit.png";
import trash from "../../trash.png";


import StawkaNew from "./StawkaNew";
import SubkontoNew from "./SubkontoNew";
import ZajeciaNew from "./ZajeciaNew";
import InputText from "../../helpers/InputText";
import InputTextEditor from "../../helpers/InputTextEditor";

import back from "../../back.png";

function ContractNew(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({


        numer_umowy2: '',  
        num_na_fakturze: '0',


        data_zawarcia: '',
        data_zawarcia_valid: false,
        data_od: '',
        data_od_valid: false,
        data_do: '',

        czas_pobytu_od: '08:00',
        czas_pobytu_od_valid: true,
        czas_pobytu_do: '17:00',
        czas_pobytu_do_valid: true,


        godziny_bezplatene_1: '0',
        godziny_bezplatene_1_valid: true,
        godziny_bezplatene_1_od: '',
        godziny_bezplatene_1_od_valid: true,
        godziny_bezplatene_1_do: '',
        godziny_bezplatene_1_do_valid: true,
        sposob_naliczania_godzin: '1',

        rekomp_nadgodzin: '0',
        sposob_naliczania_nadgodzin: '0',

        godziny_bezplatene_1_pn_od: '',
        godziny_bezplatene_1_pn_do: '',
        godziny_bezplatene_1_wt_od: '',
        godziny_bezplatene_1_wt_do: '',
        godziny_bezplatene_1_sr_od: '',
        godziny_bezplatene_1_sr_do: '',        
        godziny_bezplatene_1_cz_od: '',
        godziny_bezplatene_1_cz_do: '',        
        godziny_bezplatene_1_pt_od: '',
        godziny_bezplatene_1_pt_do: '',     
        
        e_wezwanie_e_mail: '1',
        e_wezwanie_sms: '1',



        stan_umowy: '1', //aktywna..
        dzieci: [],


        okres_do_wystawienia: '',
        okres_do_wystawienia_valid: false,
        e_faktura: '1',
        e_sms: '1',
        odsetki_ustawowe: '0',

        roz_na_koniec_m: '0',


        newStawka: '_x_',
        stawki: [],

        newZajecia: '_x_',
        zajecia: [], 

    });


    const [p_subkonta_id1, setPSubKontoId1] = useState("_x_");
    const [p_subkonta_id2, setPSubKontoId2] = useState("_x_");

 
    const [subkonta, setSubkonta] = useState(null);
    const [stawki, setStawki]     = useState(null);
    const [zajecia, setZajecia] = useState(null);

    const [pdf, setPDF] = useState(0);


    const stDelete = (e) => {

        var idx = e.target.getAttribute('id');

        //var oldTab = JSON.stringify(row.stawki);
        var newArr = new Array();

        for(var k=0; k<row.stawki.length; k++)
        {
            if(row.stawki[k].id == idx ) continue

            newArr.push(row.stawki[k]);
        }

        setRow( {...row, ["stawki"]: newArr  } );

    }

    const stDeleteZ = (e) => {

        var idx = e.target.getAttribute('id');

        //var oldTab = JSON.stringify(row.stawki);
        var newArr = new Array();

        for(var k=0; k<row.zajecia.length; k++)
        {
            if(row.zajecia[k].id == idx ) continue

            newArr.push(row.zajecia[k]);
        }

        setRow( {...row, ["zajecia"]: newArr  } );

    }



    const getSubkonta = () => {
       
 
        props.mainView.setProgress(-2);

        
        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,subkonta', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') 
                        {
                            setSubkonta(res.result);   

                            if(res.result.length == 1)
                                {
                                    setPSubKontoId1(  res.result[0]['id']  );
                                    //subkonta[kI]['id']
                                }

                        }

                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getZajecia = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            archiwalne:'0',
        };

        fetch( Config.url + '/rest_v1_calc,zajecia_dodatkowe', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setZajecia(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getStawki = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,stawki', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setStawki(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    
    const valChangeListener = (filedName, val, correct, msg) => { 
       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
       
       if(filedName == 'data_od' &&   (row.okres_do_wystawienia == null || row.okres_do_wystawienia.length < 2  ) )
       {          
            var okrD = val;

            var c = okrD.split('-');
            if(c.length == 3)
            {
                c[2] = '01';
                okrD = c[0] + '-' + c[1] + '-' + c[2];
            }  

            setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct, ['okres_do_wystawienia']:okrD,  ['okres_do_wystawienia_valid']:true } );  
            return;  //okres_do_wystawienia
       }

        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }


    const valChangeListenerSubkonto1 = (filedName, val, correct, msg) => { 
       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
        setPSubKontoId1(val);      
    }


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }




    const valChangeListenerStawka = (filedName, val, correct, msg) => { 
        console.log("valChangeListenerStawka: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
        //setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );  
        
        var exp = filedName.split('@');
        var id = exp[0];
        var filed = exp[1];

        console.log(id, filed, val);

        for(var k=0; k<row.stawki.length; k++)
        {
            if(row.stawki[k].id == id ) 
            {
                row.stawki[k][filed] = val;
            }
        }

        setRow( {...row, ["stawki"]: row.stawki } );

    }


    const itemsBezplatne = [ 
        {v: '0', title: 'Ta opcja nas nie dotyczy'},
        {v: '1', title: 'Tak, mamy bezpłatne godziny w placówce'},
        {v: '5', title: 'Tak, 5 godzin do wykorzystania w ciągu całego dnia'},
    ];


    const itemsNaliczanie = [ 
        {v: '0', title: 'Przelicz według deklarowanego czasu pobytu'},
        {v: '1', title: 'Według zarejestrowanych wejść i wyjść (jeśli nie ma to według deklarowanego czasu pobytu )'},
        {v: '3', title: 'Według zarejestrowanych wejść i wyjść (jeśli nie ma to ustaw 00:00)'},
    ];


    const itemsOdsetki = [   
        {v: '1', title: 'Tak, naliczaj w przypadku płatności po terminie'},
        {v: '0', title: 'Nie, pomiń naliczanie odsetek'},
    ];


    const itemsRozKoniec = [   
        {v: '0', title: 'Tak (zalecane, pierwsze dni miesiąca)'},
        {v: '1', title: 'Nie (ostatnie dni miesiąca)'},
    ];



    const onKidsSelected = (tab) => {
        setRow( {...row, ["dzieci"]: tab  } );
    }



    const showPDF = () => {

            if(pdf == 1) {
                setPDF(0);
            }else setPDF(1);

    }



    const saveData = (e) => {

       

        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


        if(row.dzieci.length < 1) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
                return; 
            }

        if(row.stawki.length < 1) 
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wybierz min. jedną stawkę' ,  "ok"  ,null); 
                    return; 
                }            
 

      
        var defText = e.target.innerHTML;

        e.target.innerHTML = "czekaj...";
        

        props.mainView.setProgress(-2);

      

        fetch( Config.url + '/rest_v1_calc,umowa_add', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 


                    props.mainView.setProgress(-1);        
                    e.target.innerHTML = defText;

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dodano umów: ' + res.result, "ok" , null); 
                                props.onBack();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
                    e.target.innerHTML = defText;
         });
                   

         return false;
    }




    const onBack = () => {
        props.onBack();
    }


    if(subkonta == null) {
        setSubkonta([])
        getSubkonta();
        return <span>...</span>
    }

    if(stawki == null) {
        setStawki([])
        getStawki();
        return <span>...</span>
    }

    if(zajecia == null) {
        setZajecia([])
        getZajecia();
        return <span>...</span>
    }



    //---subkonta...
    var itemsSubKonta = new Array();

    var sRow = {
        v: "_x_",
        title: ' - - - ',
    }
    itemsSubKonta.push(sRow);

    for(var kI=0; kI<subkonta.length; kI++)
    {
        var sRow = {
            v:  subkonta[kI]['id'],
            title:subkonta[kI]['nazwa'] +" / " +subkonta[kI]['numer_konta'],
        }
        itemsSubKonta.push(sRow);
    }

    //---subkonta...    





    var arrStawki = new Array();

    var sRow = {
        v: "_x_",
        title: ' - - - ',
    }
    arrStawki.push(sRow);
    

    for(var sI=0; sI<stawki.length; sI++)
    {

        for(var kI=0; kI<subkonta.length; kI++)
            {
                   if(    subkonta[kI]['id'] != p_subkonta_id1) continue;

                   var nVal = stawki[sI]['id'] + "___" + subkonta[kI]['id'];

                    var sRow = {
                        v: nVal,
                        //title: stawki[sI]['nazwa'] + " | " + stawki[sI]['kwota_netto']  + "zł | "+  subkonta[kI]['nazwa'] +" / " +subkonta[kI]['numer_konta'] +" ",
                        title: stawki[sI]['nazwa'] + " | " + stawki[sI]['kwota_netto']  + "zł  ",
                    }
            
                    arrStawki.push(sRow);


                    if(row.newStawka != '_x_' && row.newStawka == nVal) // cos wybrano.. wiec z automatu dodaj do tablicy..
                        {
                            var oldTab = JSON.stringify(row.stawki);
                            oldTab = JSON.parse(oldTab);
                            oldTab.push(
                                {
                                    id: nVal,

                                    p_typy_oplat:  stawki[sI]['id'], 
                                    nazwa_stawki:  stawki[sI]['nazwa'], 
                                    kwota_netto:  stawki[sI]['kwota_netto'], 
                                    naliczanie_dzienne:  stawki[sI]['naliczanie_dzienne'], 
                                    naliczanie_miesieczne:  stawki[sI]['naliczanie_miesieczne'], 
                                    naliczanie_godzinowe:  stawki[sI]['naliczanie_godzinowe'], 
                                    naliczanie_nadgodzin:  stawki[sI]['naliczanie_nadgodzin'], 
                                    naliczanie_jednorazowe:  stawki[sI]['naliczanie_jednorazowe'], 
                                    rozliczaj_normalnie:  stawki[sI]['rozliczaj_normalnie'], 
                                    naliczanie_wlasne:  stawki[sI]['naliczanie_wlasne'], 
                                    naliczanie_wlasne_symbol:  stawki[sI]['naliczanie_wlasne_symbol'], 
                                    naliczaj_z_gory:  stawki[sI]['naliczaj_z_gory'], 

                                    p_subkonta_id: subkonta[kI]['id'], 
                                    nazwa_konta:   subkonta[kI]['nazwa'], 
                                    numer_konta:   subkonta[kI]['numer_konta'], 

                                    data_od: null,
                                    data_do: null,
                                }
                            );
                       
                            setRow({...row, ["stawki"]: oldTab, ["newStawka"]:'_x_' });      
                            if(subkonta.length > 1)  setPSubKontoId1('_x_');                 
                          
                        }

            }   
    }   
 
    var reqStawka = '1';
    if(row.stawki.length >0 ) reqStawka = '0';























    var arrZajecia = new Array();

    var sRow = {
        v: "_x_",
        title: ' - - - ',
    }
    arrZajecia.push(sRow);
    

    for(var sI=0; sI<zajecia.length; sI++)
    {

        for(var kI=0; kI<subkonta.length; kI++)
            {
                   var nVal = zajecia[sI]['id'] + "___" + subkonta[kI]['id'];

                    var sRow = {
                        v: nVal,
                        title: zajecia[sI]['nazwa'] + " | " + zajecia[sI]['kwota'] + " zł | "+  subkonta[kI]['nazwa'] +" / " +subkonta[kI]['numer_konta'] +"  ",
                    }
            
                    arrZajecia.push(sRow);


                    if(row.newZajecia != '_x_' && row.newZajecia == nVal) // cos wybrano.. wiec z automatu dodaj do tablicy..
                        {
                            var oldTab = JSON.stringify(row.zajecia);
                            oldTab = JSON.parse(oldTab);
                            oldTab.push(
                                {
                                    id: nVal,

                                    p_typy_oplat:  zajecia[sI]['id'], 
                                    nazwa_zajecia:  zajecia[sI]['nazwa'], 
                                    kwota:  zajecia[sI]['kwota'],        

                                    p_subkonta_id: subkonta[kI]['id'], 
                                    nazwa_konta:   subkonta[kI]['nazwa'], 
                                    numer_konta:   subkonta[kI]['numer_konta'], 


                                }
                            );
                       
                            setRow({...row, ["zajecia"]: oldTab, ["newZajecia"]:'_x_' });                       
                          
                        }

            }   
    }   
 
    var reqZajecia = '1';
    if(row.zajecia.length >0 ) reqZajecia = '0';




   var timeD = Config.timeBetwwen(row.czas_pobytu_od, row.czas_pobytu_do);
   var timeInfo = "..";

   if(row.godziny_bezplatene_1 == 5) //5h za free...
   {
        timeD -= 300;
   }

   if(timeD < 60)
   {
         timeInfo =  parseInt(timeD) + " min. "; console.log("tak");
   }else 
   if(timeD == 60)
   {
         timeInfo =  "1 min. ";
   }else  
   if(timeD > 60)
   {
         var hh = parseInt(timeD / 60);
         var min = parseInt(timeD % 60);
         timeInfo = hh + " godz. i " + min + " min.";
         if(min == 0)  timeInfo = hh + " godz.";
   }else timeInfo = "?";
   
 



 

    return  <div className="view_content">
        

           <img src={back} onClick={onBack} className="back_img" title="wstecz"/>


            <h1><PlTitle userData={props.userData} /> / Nowa umowa </h1>


          
            <div className="form_tab">               
                        <InputKidsMulti   userData={props.userData}  mainView={props.mainView} onKidsSelected={onKidsSelected} stan_umowy="_y_"  />  
            </div>



            <div className="form_tab_title">Dane podstawowe umowy</div>
            <div className="form_tab">
                    
        
                    <div className="form_control">
                                        <div className="fieldName"> Nr umowy (puste jeśli auto.)</div>
                                        <InputText   userData={props.userData} value={row.numer_umowy2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_umowy2" placeholder={""} className=' ' req='0'   />
                    </div>


                    <div className="form_control">
                                        <div className="fieldName">Data zawarcia* </div>
                                        <InputDate   userData={props.userData} value={row.data_zawarcia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_zawarcia" placeholder={""} className=' ' req='1'   />
                    </div>

                    <div className="form_control">
                                        <div className="fieldName">Obowiązuje od (od kiedy zacząć naliczanie opłat?)* <b className="amount_minus">**</b> </div>
                                        <InputDate   userData={props.userData} value={row.data_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={""} className=' ' req='1'   />
                    </div>

                    <div className="form_control">
                                        <div className="fieldName">Obowiązuje do (puste jeśli nieokreślono) * </div>
                                        <InputDate   userData={props.userData} value={row.data_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={""} className=' ' req='0'   />
                    </div>
            </div>

            <p>
                <b className="amount_minus">**</b> Data ta wskazuje od jakiego dokładnie dnia mają być naliczanie opłaty, tj. naliczanie opłat za posiłki, możliwość zgłaszana nieobecności na dni zaczynając od podanego tutaj.   Przykład: Jeżeli dziecko zaczyna uczęszczać do placówki od 17 września to ustaw datę 17 września.
            </p>

 
            <div className="form_tab">

                 
                    <div className="form_control">
                                            <div className="fieldName">Rozliczenie na początku miesiąca* </div>
                                            <InputCombo   items={itemsRozKoniec}  value={row.roz_na_koniec_m} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="roz_na_koniec_m" placeholder={""} className=' ' req='1'   />
                    </div>

                    <div className="form_control">
                                            <div className="fieldName">Kiedy wystawić pierwszy rachunek lub fakturę? (zazwyczaj to pierwsze dni miesiąca) * </div>
                                            <InputDate   userData={props.userData} value={row.okres_do_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="okres_do_wystawienia" placeholder={""} className=' ' req='1'   />
                    </div>

                    <div className="form_control">
                                            <div className="fieldName">Naliczać odsetki w przypadku braku płatności?* </div>
                                            <InputCombo   items={itemsOdsetki}  value={row.odsetki_ustawowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odsetki_ustawowe" placeholder={""} className=' ' req='1'   />
                    </div>
            </div> 



            <div className="h_separate">
                       Deklarowany czas pobytu ({timeInfo})
            </div>




            <div className="form_tab_title">Deklarowany czas pobytu, sposób naliczania godzin i nadgodzin</div>
            <div className="form_tab">

                 
                    <div className="form_control">
                                            <div className="fieldName">Czas pobytu OD* </div>
                                            <InputTime   userData={props.userData} value={row.czas_pobytu_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="czas_pobytu_od" placeholder={""} className=' ' req='0'   />
                    </div>

                    <div className="form_control">
                                            <div className="fieldName">Czas pobytu DO* </div>
                                            <InputTime   userData={props.userData} value={row.czas_pobytu_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="czas_pobytu_do" placeholder={""} className=' ' req='0'   />
                    </div>



                    <div className="form_control">
                        &nbsp;&nbsp;&nbsp;        &nbsp;&nbsp;&nbsp;
                    </div> 

                    <div className="form_control">
                                      <div className="fieldName">Godziny bezpłatnego pobytu</div>
                                      <InputCombo  items={itemsBezplatne} value={row.godziny_bezplatene_1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1" placeholder={""} className='  ' req='1'   />                                    
                    </div>

              

                    {
                                        row.godziny_bezplatene_1 != 0 && row.godziny_bezplatene_1 != 5 &&
                                        <React.Fragment>
                                          
                                          <div className="form_control">
                                            <div className="fieldName">Godzina od* </div>
                                            <InputTime   userData={props.userData} value={row.godziny_bezplatene_1_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1_od" placeholder={""} className=' w150' req='1'   />
                                         </div>

                                         <div className="form_control">
                                            <div className="fieldName">Godzina do* </div>
                                            <InputTime   userData={props.userData} value={row.godziny_bezplatene_1_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godziny_bezplatene_1_do" placeholder={""} className=' w150' req='1'   />
                                         </div>


                                        </React.Fragment>                                        
                    }
                    <br/>
                    <div className="form_control">
                                      <div className="fieldName">Sposób obliczania godzin pobytu</div>
                                      <InputCombo  items={itemsNaliczanie} value={row.sposob_naliczania_godzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_naliczania_godzin" placeholder={""} className='  ' req='1'   />                                    
                    </div>

                    <div className="form_control">
                                      <div className="fieldName">Nadgodziny to</div>
                                      <InputCombo  items={ [{v:'0',title: 'Przyjście przed ' + row.czas_pobytu_od + " / wyjście po " + row.czas_pobytu_do  }, {v:'1',title: 'Czas wykraczający ponad deklarowany, ' + timeInfo    } ]   } value={row.sposob_naliczania_nadgodzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_naliczania_nadgodzin" placeholder={""} className='  ' req='1'   />                                    
                    </div>

                    {
                        row.sposob_naliczania_nadgodzin == 0 &&
                        <Fragment>
                            <div className="form_control">
                               <div className="fieldName">Rekompensata nadgodzin*</div>
                                                        <InputCombo  items={ [ {v:'0',title:'Nie'}, {v:'1',title:'Tak'},  ] } value={row.rekomp_nadgodzin} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rekomp_nadgodzin" placeholder={""} className='  ' req='1'   />   
                                        </div>
                                        <br/>
                                        <div>
                                        Rekompensata nadgodzin*  - jeżeli dziecko przyjedzie X minut przed deklarowanym czasem ({row.czas_pobytu_od}) i wyjdzie wcześniej, X minut przed {row.czas_pobytu_do} to nadgodziny zostaną wyzerowane lub zrekompensowane.
                                            
                                        <a  className="link_color" href="https://elizak.edu.pl/app/view/image/godziny_pobytu.pdf" target="_blank"> Pokaż widok poglądowy</a>
                               </div>
                        </Fragment>
                    }

                  


            </div>





                    <div className="h_separate">
                        Stawki i opłaty
                    </div>

            <div className="form_tab_title">Powiązane stawki ({row.stawki.length}) </div>            
            <div className="form_tab">

                <table className="table" >
                            <tr>
                                 {
                                    subkonta.length > 1 &&
                                    <td>
                                    * Wybierz nr rach. by przypisać stawkę:
                                     <InputCombo   items={itemsSubKonta}  value={p_subkonta_id1} err={errTab}  valChange={valChangeListenerSubkonto1} goNext={goNextNew} name="p_subkonta_id1" placeholder={""} className=' ' req="0"   />
                                    </td>
                                 }                                

                                <td>        
                                          * Wybierz stawkę:                                
                                         <InputCombo   items={arrStawki}  value={row.newStawka} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="newStawka" placeholder={""} className=' ' req={reqStawka}   />
                                </td>


                                <td className="gocenter">LUB</td>
                                
                                <td className="goright">
                                        <StawkaNew  userData={props.userData} mainView={props.mainView} onAdded={getStawki} />                                                        
                                </td>
                            </tr>
                        </table>

                        <br/>                   
                        { row.stawki.length > 0 && 
                        <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Nazwa stawki</td>  
                                                <td>Sposób naliczania</td>                                                                                     
                                                <td>Kwota</td>   
                                                <td>Powiązane konto</td>                                               
                                                <td>Naliczanie OD**</td>                                               
                                                <td className="td_right">Naliczanie DO**</td>                                               
                                                <td className="td_option"></td>                                                                                   
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                row.stawki.map( (st, ix) => {


                                                     var sp = '';
                                                    if(st.naliczanie_jednorazowe == '1')   sp = "Jednorazowo";
                                                    if(st.naliczanie_dzienne == '1')       sp = "Dziennie";
                                                    if(st.naliczanie_miesieczne == '1')    sp = "Miesięcznie";
                                                    if(st.naliczanie_godzinowe == '1')    sp = "Godzinowe";
                                                    if(st.naliczanie_nadgodzin == '1')    sp = "Nadgodzinowe";
                                                    if(st.naliczanie_wlasne == '1')    sp = "Własne";

                                                    if(st.naliczaj_z_gory == '1')
                                                    {
                                                        sp = sp + " - z góry";
                                                    }else
                                                    {
                                                        sp = sp + " - za okres miniony"; 
                                                    }



                                                    var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return <tr className={rowStyle}>
                                                                <td className="gocenter">{ix+1}</td>
                                                                <td className="gocenter">{st.nazwa_stawki}</td>  
                                                                <td className="gocenter">{sp}</td>                                                                                     
                                                                <td className="goright">{st.kwota_netto}</td>   
                                                                <td className="gocenter">{st.nazwa_konta + ", " + st.numer_konta}</td>  


                                                                <td className="gocenter">                                                                    
                                                                    <InputDate   userData={props.userData} value={st.data_od} err={[]}  valChange={valChangeListenerStawka} goNext={null} name={ st.id + "@data_od"  } placeholder={""} className=' ' req='0'   />
                                                                </td>                                               

                                                                <td className="gocenter">
                                                                    <InputDate   userData={props.userData} value={st.data_do} err={[]}  valChange={valChangeListenerStawka} goNext={null} name={ st.id + "@data_do"  } placeholder={""} className=' ' req='0'   />
                                                                </td>      



                                                                <td className="td_btn_option"><img className="ibtn" src={trash} title="Usuń"   onClick={stDelete} v="delete" id={st.id}  /> </td>   

                                                    </tr>
                                                }  )
                                            }
                                        </tbody>

                        </table>
                        }

                        <br/>
                        <div>
                            *&nbsp; Jeżeli przypiszesz np. dwie stawki z różnymi numerami konta to system wystawi dwa dokumenty, na każdym z tych dokumentów będą różne nr rach. do wpłat.
                        </div>
                        <div>
                            ** Pozostaw puste jeżeli stawka ma obowiązywać przez cały okres umowy. Okres ten możesz zawsze później zmienić. 
                        </div>                       

            </div>


            <div className="h_separate">
                        Zajęcia dodatkowe
            </div>


            <div className="form_tab_title">Zajęcia dodatkowe ({row.zajecia.length}) </div>    
            
            <div className="form_tab">
                
                   <table className="table" >
                            <tr>
                                <td>
                                        Przypisz zajęcia dodatkowe <InputCombo   items={arrZajecia}  value={row.newZajecia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="newZajecia" placeholder={""} className=' ' req="0"   />
                                </td>

                                <td className="gocenter">LUB</td>
                                
                                <td className="goright">
                                        <ZajeciaNew  userData={props.userData} mainView={props.mainView} onAdded={getZajecia} />                                                                 
                                </td>
                            </tr>
                        </table>

                        <br/>  

                        { row.zajecia.length > 0 &&    
                        <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Nazwa</td>                                                                                                                            
                                                <td>Kwota</td>   
                                                <td className="td_right">Powiązane konto</td>                                               
                                                <td className="td_option"></td>                                                                                   
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                row.zajecia.map( (st, ix) => {


                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                    return <tr className={rowStyle}>
                                                                <td className="gocenter">{ix+1}</td>
                                                                <td className="gocenter">{st.nazwa_zajecia}</td>                                                                                                                         
                                                                <td className="goright">{st.kwota}</td>   
                                                                <td className="gocenter">{st.nazwa_konta + ", " + st.numer_konta}</td>                                               
                                                                <td className="td_btn_option"><img className="ibtn" src={trash} title="Usuń"   onClick={stDeleteZ} v="delete" id={st.id}  /> </td>   
                                                    </tr>
                                                }  )
                                            }
                                        </tbody>

                        </table>
                        }
            </div>
          


            <div className="h_separate  ">
                       
            </div>
            <div onClick={showPDF} className="link_color gocenter  ">-</div>

           { pdf == 1  && 1==2 &&

            <div className="form_tab">
                   <InputTextEditor  value={"d here is example for more complex selections on <i>TO JEST MÓJ <b>BA<span style='color:red;'>R</span>DZO</b>POCHYLONY TEKST</i> page based "} />
            </div>

           }
           
                                                


            <br/>        
            <br/>        

            <div className="form_control">                                            
                       <div className="btn" onClick={saveData}>utwórz umowę</div>
                       &nbsp; &nbsp;
                       <div className="btn" onClick={onBack}>anuluj</div>
            </div>

    </div>
}




export default ContractNew;
